<!-- tODO this should be a filtered list, not this generic thing.-->
<template>
  <div>
    <div v-if="summary" class="flex justify-space-evenly flex-wrap-sm-only">
      <div class="w-full">
        <h2 class="dashboard-stat-label m-t-none">
          Marked Present
        </h2>
        <div class="dashboard-stat-value">
          <i class="fa-solid fa-check text-green-500"></i> {{ summary.attended_count }}
          <span class="text-gray-700 font-normal font-small">times</span>
        </div>
      </div>
      <div class="w-full">
        <h2 class="dashboard-stat-label m-t-none">
          Marked Absent
        </h2>
        <div class="dashboard-stat-value">
          <i class="fa-solid fa-xmark text-red-500"></i> {{ summary.absent_count }}
          <span class="text-gray-700 font-normal font-small">times</span>
        </div>
      </div>
      <div class="w-full">
        <h2 class="dashboard-stat-label m-t-none">
          Last Attended
        </h2>
        <div class="dashboard-stat-value">
          <i :class="lastAttendedIconClass"></i>
          {{ lastAttendedText }}
        </div>
      </div>
    </div>
    <hr v-if="summary" class="m-t-lg m-b-lg"/>
    <div class="grid grid-cols-3 sm-grid-cols-1 gap-x-sm m-t-md m-b-m">
      <div :class="filterClass('all')" @click="status = 'all'">
        All
      </div>
      <div :class="filterClass('present')" @click="status = 'present'">
        Present
      </div>
      <div :class="filterClass('absent')" @click="status = 'absent'">
        Absent
      </div>
    </div>
    <paged-list response-key="check_ins" object-type="CheckIn" help-text="" :base-url="baseUrl">
      <template v-slot:list="slotProps">
        <div class="flex flex-col border border-b p-y-sm border-solid border-gray-50">
          <div class="flex gap-x-sm align-items-baseline">
            <i :class="iconClass(slotProps.result.status)"></i>
            <div>
              <p class="font-normal text-16 m-t-none m-b-none">
                <template v-if="slotProps.result.event_id">
                  <a :href="`/events/${slotProps.result.event_id}`">{{ slotProps.result.event_name }}</a>
                </template>
                <template v-else>
                  Generic Check In
                </template>
                <span v-if="showsStatusLabel(slotProps.result.status)" class="label m-l-xs">{{ statusLabel(slotProps.result.status) }}</span>
              </p>
              <p class="search-type-label m-b-none">Recorded at {{ formatWithMoment(slotProps.result.created_at, 'llll') }}</p>
              <p class="m-b-none m-t-xxs" v-if="slotProps.result.class_pass_id">
                <span class="label">Class Pass Used<template v-if="slotProps.result.class_pass.paid_session"> - {{ slotProps.result.class_pass.paid_session.name }}</template><template v-else-if="slotProps.result.class_pass.billing_subscription && slotProps.result.class_pass.billing_subscription.name"> - {{ slotProps.result.class_pass.billing_subscription.name }}</template></span>
              </p>
            </div>
          </div>
        </div>
      </template>
    </paged-list>
  </div>
</template>
<script>
import PagedList from './paged_list.vue';
import { formattingMixin } from './mixins/formatting_mix';

export default {
  name: 'wrestler-check-in-list',
  components: {
    PagedList,
  },
  mixins: [formattingMixin],
  props: {
    wrestlerProfileId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      status: 'all',
      summary: null,
    };
  },
  computed: {
    baseUrl() {
      return this.$apiService.wrestlerCheckIns(this.wrestlerProfileId, this.ransackQuery);
    },
    ransackQuery() {
      switch (this.status) {
        case 'all':
          return { q: { s: 'created_at desc' } };
        case 'present':
          // Present and late (CheckIn::ATTENDED_STATUSES)
          return { q: { attended: true, s: 'created_at desc' } };
        default:
          // Everything else except unknown (CheckIn::DID_NOT_ATTEND_STATUSES)
          return { q: { did_not_attend: true, s: 'created_at desc' } };
      }
    },
    lastAttendedText() {
      const days = this.summary.days_since_last_attended;
      return days === null ? 'N/A' : `${days} days ago`;
    },
    lastAttendedIconClass() {
      const days = this.summary.days_since_last_attended;
      if (days === null || days < 7) {
        return 'fa-solid fa-clock-rotate-left';
      }
      if (days < 14) {
        return 'fa-solid fa-clock-rotate-left text-yellow-500';
      }
      return 'fa-solid fa-clock-rotate-left text-red-500';
    },
  },
  created() {
    axios.get(this.$apiService.wrestlerCheckInsSummaryUrl(this.wrestlerProfileId))
      .then((response) => {
        this.summary = response.data;
      })
      .catch(() => {
        // The stats are a nicety; the list below still works without them
      });
  },
  methods: {
    filterClass(status) {
      if (status === this.status) {
        return 'border border-solid border-2 rounded-xs border-blue-600 text-blue-600 font-heavy p-sm cursor-pointer';
      }

      // Default gray pill
      return 'border border-solid rounded-xs border-gray-400 text-gray-400 p-sm cursor-pointer';
    },
    // Name the status when the icon alone doesn't (late, excused, injured...)
    showsStatusLabel(status) {
      return !['present', 'absent', 'unknown'].includes(status);
    },
    statusLabel(status) {
      return status.charAt(0).toUpperCase() + status.slice(1);
    },
    iconClass(status) {
      switch (status) {
        case 'present':
          return 'fa-solid fa-check text-green-500';
        case 'late':
          return 'fa-solid fa-clock text-yellow-500';
        case 'unknown':
          return 'fa-solid fa-question text-gray-500';
        default:
          return 'fa-solid fa-xmark text-red-500';
      }
    },
  },
};
</script>
